import React from 'react';
import { Modal, Button, Typography, Flex } from 'antd';
import { PlayCircleOutlined, LoadingOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface StartInterviewModalProps {
  isOpen: boolean;
  isLoading: boolean;
  loadingMessage?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  containerRef?: React.RefObject<HTMLElement>;
}

const StartInterviewModal: React.FC<StartInterviewModalProps> = ({
  isOpen,
  isLoading,
  loadingMessage,
  onConfirm,
  onCancel,
  containerRef,
}) => {
  return (
    <Modal
      title={null}
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      centered
      closable={!isLoading}
      maskClosable={!isLoading}
      width={480}
      getContainer={containerRef?.current || document.body}
      styles={{
        body: { padding: '32px 24px 24px' }
      }}
    >
      <Flex vertical align="center" gap={24}>
        <PlayCircleOutlined 
          style={{ 
            fontSize: '64px', 
            color: '#1890ff',
            opacity: isLoading ? 0.6 : 1 
          }} 
        />
        
        <Flex vertical align="center" gap={8}>
          <Title level={3} style={{ margin: 0, textAlign: 'center' }}>
            {isLoading ? 'Preparing Interview' : 'Ready to Start Interview'}
          </Title>
          
          <Text 
            type="secondary" 
            style={{ 
              textAlign: 'center',
              fontSize: '14px',
              lineHeight: '1.5'
            }}
          >
            {isLoading 
              ? (loadingMessage || 'Please wait while we prepare your interview...')
              : 'Camera and microphone access confirmed. Click "Start Interview" to begin your session in fullscreen mode.'
            }
          </Text>
        </Flex>

        {isLoading ? (
          <Flex align="center" gap={8}>
            <LoadingOutlined style={{ fontSize: '16px', color: '#1890ff' }} />
            <Text type="secondary">Loading...</Text>
          </Flex>
        ) : (
          <Flex gap={12} style={{ width: '100%' }}>
            <Button
              size="large"
              onClick={onCancel}
              style={{ flex: 1 }}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              onClick={onConfirm}
              style={{ flex: 1 }}
              disabled={isLoading}
              icon={<PlayCircleOutlined />}
            >
              Start Interview
            </Button>
          </Flex>
        )}
      </Flex>
    </Modal>
  );
};

export default StartInterviewModal;